import { memo, useCallback, useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/Header.css';
import { Calculator } from "lucide-react";
import { FileDown } from "lucide-react";
import SidebarNav from '../components/SidebarNav';
import { downloadBrochure } from '../utils/downloadBrochure';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 1024);

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1025px)');
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', handler);
    setIsDesktop(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  const handleBrochureDownload = useCallback(async () => {
    await downloadBrochure();
  }, []);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  return (
    <header className="header">
      <div className="header-container">
        
        {/* LOGO */}
        <div className="logo">
          <Link to="/">
            <img 
              src="/assets/logo/logo4.jpeg" 
              alt="V SQUARE RENEWABLES" 
              className="logo-img"
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />
          </Link>
        </div>

        <div className="header-actions">
          
          {/* NAVIGATION — desktop only */}
          {isDesktop && (
          <nav className={menuOpen ? 'nav-menu open' : 'nav-menu'}>
            
            <NavLink 
              to="/" 
              end 
              className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}
              onClick={closeMenu}
            >
              Home
            </NavLink>

            {/* SERVICES MEGA MENU */}
            <NavLink 
              to="/services" 
              className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}
              onClick={closeMenu}
            >
              Services
            </NavLink>

            <NavLink 
              to="/about" 
              className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}
              onClick={closeMenu}
            >
              About
            </NavLink>

            <NavLink 
              to="/contact" 
              className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}
              onClick={closeMenu}
            >
              Contact
            </NavLink>

            <NavLink 
              to="/government-schemes" 
              className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}
              onClick={closeMenu}
            >
              Govt. Schemes
            </NavLink>

            <NavLink 
              to="/news" 
              className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}
              onClick={closeMenu}
            >
              News & Updates
            </NavLink>

            <NavLink 
              to="/solar-calculator" 
              className={({ isActive }) => isActive ? 'icon-btn-animated is-active' : 'icon-btn-animated'}
              onClick={closeMenu}
              title="Solar Calculator"
              aria-label="Solar Calculator"
            >
              <span className="icon-btn-icon"><Calculator size={20} /></span>
              <span className="icon-btn-label">Calculator</span>
            </NavLink>

            <button
              className="icon-btn-animated"
              onClick={handleBrochureDownload}
              title="Download Brochure"
              aria-label="Download Brochure"
            >
              <span className="icon-btn-icon"><FileDown size={20} /></span>
              <span className="icon-btn-label">Brochure</span>
            </button>

          </nav>
          )}





{/* <NavLink
  to="/solar-calculator"
  className={({ isActive }) =>
    isActive
      ? "icon-button calculator-btn is-active"
      : "icon-button calculator-btn"
  }
  onClick={() => setMenuOpen(false)}
  title="Solar Calculator"
  aria-label="Solar Calculator"
>
  <Calculator className="nav-icon" size={22} />
</NavLink>

<button
  className="icon-button download-btn"
  onClick={handleBrochureDownload}
  title="Download Brochure"
  aria-label="Download Brochure"
>
  <img 
    src="/assets/logo/file.png" 
    alt="Download Brochure"
    className="nav-icon-img"
  />
</button> */}

          {/* CTA BUTTON */}
          {/* <Link 
            to="/contact" 
            className="cta-button"
            onClick={closeMenu}
          >
            Get Quote
          </Link> */}

          {/* MOBILE TOGGLE */}
          <button
            type="button"
            className={menuOpen ? 'menu-toggle active' : 'menu-toggle'}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={toggleMenu}
          >
            <span />
            <span />
            <span />
          </button>

           {/* SIDEBAR NAV */}
           <SidebarNav />

        </div>
      </div>
    </header>
  );
};

export default memo(Header);
